import { render, staticRenderFns } from "./CompanyDataUpdateEscalationFile.vue?vue&type=template&id=3813adca&scoped=true&"
import script from "./CompanyDataUpdateEscalationFile.vue?vue&type=script&lang=js&"
export * from "./CompanyDataUpdateEscalationFile.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDataUpdateEscalationFile.vue?vue&type=style&index=0&id=3813adca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3813adca",
  null
  
)

export default component.exports